// const API_URL = 'http://localhost:5000/api';
const API_URL = 'https://manish-portfolio-api.onrender.com/api';

export default API_URL;

